import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const StateColumn = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};
  const { labelConfiguration, externalFulfillmentConfiguration } =
    useSelector((state) => Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId })) ?? {};

  const shipTo = labelConfiguration?.shipTo ?? externalFulfillmentConfiguration?.shipTo;

  const { state } = shipTo ?? {};

  return state ?? '';
};

StateColumn.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const State = {
  getMessageDescriptor: () => messages.state,
  id: 'state',

  render: (data) => {
    return data && <StateColumn fulfillmentId={data.id} />;
  },
};
